import { connect } from 'react-fela'; // eslint-disable-line behance/no-deprecated
import { hocDisplayName, addDisplayName } from './displayName';

export var getDisplayName = hocDisplayName('ConnectedFelaComponent');

var createComponentStyles = function createComponentStyles(styleFunctions, component) {
  var ConnectedComponent = connect(styleFunctions)(component);
  addDisplayName(ConnectedComponent, component, getDisplayName);
  return ConnectedComponent;
};

export default createComponentStyles;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/style-container/es/createComponentStyles.js
// module id = 928
// module chunks = 1